import React from "react";

export default function Services() {
  return (
    <section className="page-container">
      <h2>Our Services</h2>
      <ul>
        <li>Dry Cleaning</li>
        <li>Laundry</li>
        <li>Ironing & Pressing</li>
        <li>Alterations</li>
      </ul>
    </section>
  );
}
